module.exports = __webpack_public_path__ + "img/hair.48658016.svg";